import {useGlobalStore} from '@/stores/global'
import {useUserStore} from '@/stores/user'
import {computed} from 'vue'

export function useCanSwitchUi() {
  const globalStore = useGlobalStore()
  const userStore = useUserStore()

  return computed(() => globalStore.hasAuthority('ADMIN') || userStore.isEmployee)
}
